import axios from 'axios';
/** Replacement for `e instanceof ApiError`. */
export const isApiError = (error) => axios.isAxiosError(error);
/**
 * Extracts a unified shape (status, body, …) from the error. Returns `undefined` if it is not an API error.
 * Optionally type the response body: `getApiError<{ message: string }>(e)?.body?.message`.
 */
export const getApiError = (error) => {
    if (!axios.isAxiosError(error))
        return undefined;
    return {
        status: error.response?.status,
        statusText: error.response?.statusText,
        body: error.response?.data,
        url: error.config?.url,
        message: error.message,
    };
};
/**
 * Convenience helper: the server-provided `body.message` of an API error, or `undefined`
 * when the error is not an API error / carries no message. Typical use: `getApiErrorMessage(e) ?? e`.
 */
export const getApiErrorMessage = (error) => getApiError(error)?.body?.message;
